import React, {useEffect, useState} from 'react'
import * as firebaseui from "firebaseui";
import 'firebaseui/dist/firebaseui.css'
import firebase from "firebase/compat/app";
import NavBar from "../NavBar";
import Radio from '@mui/material/Radio';
import nflImage from '../images/nfl-page-example.png'
import unitedStatesExample from '../images/united-states-example.png'
import europeExample from '../images/europe-example.png'
import profileExample from '../images/profile-example.png'
import websiteLogo from "../images/website-logo.png"
import latestWebsiteLogo from "../images/latest-website-logo-no-background.png"


const AuthFireBase = ({onUserLogin}) => {
    const [selectedValue, setSelectedValue] = React.useState('a');
    const [currentInterval, setCurrentInterval] = useState(null)

    const homePageImageObject = {
        a: {
            text: 'Track your progress on lifetime goals, like visiting all 32 NFL stadiums.',
            image: nflImage
        },
        b: {
            text: 'See how close you are to visiting all 50 states in the USA.',
            image: unitedStatesExample
        },
        c: {
            text: 'Track your progress as you visit each country in Europe.',
            image: europeExample
        },

        d: {
            text: 'Keep track of your favorite trips and photos all in one place.',
            image: profileExample
        },
    }

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        if (currentInterval) {
            clearInterval(currentInterval)
            setCurrentInterval(null)
        }
    };
    useEffect(() => {
        const ui = firebaseui?.auth?.AuthUI?.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
        ui.start("#firebaseui-auth-container", {
            signInOptions: [
                {
                    signInMethod: firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD,
                    provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
                    requireDisplayName: true
                },
            ],
            signInFlow: 'popup',
            signInSuccessUrl: "/trips",
            callbacks: {
                signInSuccessWithAuthResult: function (authResult, redirectUrl) {
                    // User successfully signed in.
                    // Return type determines whether we continue the redirect automatically
                    // or whether we leave that to developer to handle.
                    onUserLogin(authResult)
                    return false;
                },
            }
        })
        const imageArray = ["a", "b", "c", "d"]
        let indexValue = 0
        const interval = setInterval(() => {
            if (indexValue < 3) {
                indexValue++
                setSelectedValue(imageArray[indexValue])
            } else {
                indexValue = 0
                setSelectedValue(imageArray[indexValue])
            }
        }, 7000)
        setCurrentInterval(interval)
    }, [])

    return (
        <div className="login-page-container">
            <NavBar onLoginPage/>
            <div className="login-page">
                <div className="login-page-div login-div">
                    <img src={latestWebsiteLogo} style={{height: '40vh', marginBottom: "50px"}}/>
                    {/*<h1 className="login-page-header">Welcome to Map-App!</h1>*/}
                    <div id="firebaseui-auth-container">
                    </div>
                </div>
                <div className="app-highlights login-page-div">

                    <h3>{homePageImageObject[selectedValue].text}</h3>
                    <img src={homePageImageObject[selectedValue].image}/>
                    <div>
                        <Radio
                            checked={selectedValue === 'a'}
                            onChange={handleChange}
                            value="a"
                            name="radio-buttons"
                            inputProps={{'aria-label': 'A'}}
                        />
                        <Radio
                            checked={selectedValue === 'b'}
                            onChange={handleChange}
                            value="b"
                            name="radio-buttons"
                            inputProps={{'aria-label': 'B'}}
                        />
                        <Radio
                            checked={selectedValue === 'c'}
                            onChange={handleChange}
                            value="c"
                            name="radio-buttons"
                            inputProps={{'aria-label': 'C'}}
                        />
                        <Radio
                            checked={selectedValue === 'd'}
                            onChange={handleChange}
                            value="d"
                            name="radio-buttons"
                            inputProps={{'aria-label': 'D'}}
                        />
                    </div>
                </div>
            </div>


        </div>

    )
}

export default AuthFireBase;